module.exports = __webpack_public_path__ + "static/media/PIONEERS.e7b15dfe.png";